import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import React from 'react'

import { NotFoundBlock } from 'app/pages/Dashboard/components/NotFoundBlock'

import * as styles from './styles'

import { TitleDescription } from '../../../../../components/TitleDescription'

export const AppVersion = (props) => {
  const { appVersionData } = props

  const formatDateWithDaysBack = (dateString) => {
    if (!dateString) return 'NA'

    const date = dayjs(dateString)
    const now = dayjs()
    const daysDiff = now.diff(date, 'day')

    if (daysDiff === 0) {
      return `today`
    } else if (daysDiff === 1) {
      return `${date.format('D MMM, YY')} (1 day ago)`
    } else {
      return `${date.format('D MMM, YY')} (${daysDiff} days ago)`
    }
  }

  return appVersionData?.current_version ? (
    <styles.Body>
      <styles.ColumnFlexCenter>
        <styles.InfoBlock>
          <TitleDescription
            heading="App Version"
            size="medium"
            align="center"
            description={appVersionData?.current_version}
          />

          <TitleDescription
            heading="Last Opened App"
            size="small"
            align="center"
            description={formatDateWithDaysBack(appVersionData?.last_opened)}
          />
        </styles.InfoBlock>
      </styles.ColumnFlexCenter>
    </styles.Body>
  ) : (
    <NotFoundBlock message="Oh no! The app is not installed yet." />
  )
}
